// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { createContext, useContext } from 'react';
import type { ApprovalPlan } from '../../../hooks/usePlanDetail';
import type { PlanFile } from '../../../types';

export interface PlanDetailContextValue {
  plan: ApprovalPlan;
  planFile: PlanFile;
  /** A pending day-ahead plan whose execution day has passed: it can no longer be reviewed. */
  expired?: boolean;
}

export const PlanDetailContext = createContext<PlanDetailContextValue | null>(null);

export function usePlanDetailContext(): PlanDetailContextValue {
  const ctx = useContext(PlanDetailContext);
  if (!ctx) {
    throw new Error('usePlanDetailContext must be used within a PlanDetailContext.Provider');
  }
  return ctx;
}
